import axiosIns from 'utils/axios'
let epmcore = 'EPM-CORE-SERVICE'
///////////////////////加班基础数据////////////////////////////
// 获取加班list
export function getdailyOverTimeAPI(params) {
  return axiosIns({
    url: `/api/pc/dailyOverTime/list`,
    owner: epmcore,
    method: 'get',
    params
  })
}
// 删除单个
export function deleteAPI(dailyOverTimeId) {
  return axiosIns({
    url: `/api/pc/dailyOverTime/delete/${dailyOverTimeId}`,
    owner: epmcore,
    method: 'DELETE',
  })
}
// 删除全部
export function deleteAllAPI(ids) {
  return axiosIns({
    url: `/api/pc/dailyOverTime/delete?ids=${ids}`,
    owner: epmcore,
    method: 'DELETE',
  })
}
// 获取项目管理
export function getProject(params) {
  return axiosIns({
    url: `/api/pc/project/page`,
    owner: epmcore,
    method: 'get',
    params
  })
}

//下载加班数据上传模版
export function downloadsAPI() {
  return axiosIns({
    url: '/api/pc/dailyOverTime/download',
    owner: epmcore,
    method: 'get',
    responseType: 'blob'
  })
}
//上传模版
export function uploadClockInExcelAPI(file) {
  return axiosIns({
    url: '/api/pc/dailyOverTime/uploadClockInExcel',
    owner: epmcore,
    method: 'post',
  })
}
//修改
export function editAPI(data) {
  return axiosIns({
    url: '/api/pc/dailyOverTime/update',
    owner: epmcore,
    method: 'PUT',
    data
  })
}
////////////////项目加班统计/////////////////
//list
export function listByProjectAPI(url) {
  return axiosIns({
    url: url,
    // url: '/api/pc/projectOverTime/listByProject',
    owner: epmcore,
    method: 'get',
  })
}
////////////////月度加班统计/////////////////
//list
export function listByMonthAPI(url) {
  return axiosIns({
    url: url,
    owner: epmcore,
    method: 'get',
  })
}

// 项目版本分页
export function getVersionAPI(params) {
  return axiosIns({
    url: `/api/pc/projectVersion/page`,
    owner: epmcore,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/views/project-manage/overtime-manage/report.js